// extracted by mini-css-extract-plugin
module.exports = {"home":"Department_home__d8QJy","textFields":"Department_textFields__1R-2V","actionButton":"Department_actionButton__15fCI","error":"Department_error__2377I"};